import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { DagSourceModel } from "@app/workflow-common/services/DagSourceModel";
import { CommonDataSource } from "@app/workflow-common/services/CommonDataSource";
import { from } from "rxjs";
import { map } from "rxjs/operators";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { SetSalesPersonBlockModel } from "@app/workflow-common/services/models/SetSalesPersonBlockModel";
import { TranslateService } from "@ngx-translate/core";
var SetSalesPersonBlockWidgetComponent = /** @class */ (function () {
    function SetSalesPersonBlockWidgetComponent(formBuilder, translate) {
        this.formBuilder = formBuilder;
        this.translate = translate;
        this.close = new EventEmitter();
        this.isLoading = true;
        this.isFormSubmitted = false;
        this.selectedUserInputs = {};
        this.showDeleteBtn = false;
    }
    SetSalesPersonBlockWidgetComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var blockObject, modelData;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.blockData = this.dagSourceModel.getBlocksSource().getBlockByKey(this.blockObject.key);
                        return [4 /*yield*/, CommonDataSource.getUserDetail().then(function (userData) {
                                var salesPersonUserList = [];
                                var userRecords = [];
                                userRecords['userRecords'] = userData ? userData : [];
                                userRecords['userRecords'].forEach(function (user) {
                                    var type = '';
                                    if (user.salesRoleId != null && (user.salesRoleId > 10 || user.salesRoleId == 9)) {
                                        salesPersonUserList.push({
                                            id: user.id,
                                            text: user.text,
                                            name: 'Sales Person'
                                        });
                                    }
                                });
                                _this.salesPersonUsers = salesPersonUserList;
                                _this.otherUsers = _this.dagSourceModel.getOtherTags('PipelineAutomation');
                            })];
                    case 1:
                        _a.sent();
                        this.setToEmailSelect2Config();
                        blockObject = tslib_1.__assign({}, this.blockObject);
                        modelData = blockObject['model'] ? blockObject['model'] : undefined;
                        if (modelData) {
                            this.showDeleteBtn = true;
                        }
                        this.inputModel = new SetSalesPersonBlockModel(modelData);
                        this.makeEmailAddressDropdownData();
                        this.form = this.formBuilder.group({
                            assignTo: new FormControl(this.selectedUserInputs['assignTo'], [Validators.required]),
                            displayValue: new FormControl(this.selectedUserInputs['displayValue']),
                        });
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    SetSalesPersonBlockWidgetComponent.prototype.closeModal = function () {
        this.close.emit({
            action: 'close',
            data: null
        });
    };
    SetSalesPersonBlockWidgetComponent.prototype.remove = function () {
        var blockObject = tslib_1.__assign({}, this.blockObject);
        blockObject.model = this.inputModel;
        this.close.emit({
            action: 'remove_block',
            data: blockObject
        });
    };
    SetSalesPersonBlockWidgetComponent.prototype.selectedUsers = function (event) {
        if (event === void 0) { event = null; }
        this.form.get('assignTo').setValue(event);
        if (event) {
            this.form.get('displayValue').setValue(this.getDisplayValue(event));
        }
    };
    SetSalesPersonBlockWidgetComponent.prototype.makeGroupUserList = function () {
        var _this = this;
        var allDropdownList = [];
        var newItems = [];
        newItems.push(this.salesPersonUsers);
        newItems.push(this.otherUsers);
        var source = from(newItems);
        var tags = source.pipe(map(function (groupItems) {
            var _item = { text: '', children: [] };
            var cnt = 0;
            groupItems.forEach(function (group) {
                if (cnt === 0) {
                    _item.text = group.name;
                }
                _item.children.push({
                    id: group.id,
                    text: _this.translate.instant(group.text)
                });
                cnt++;
            });
            return _item;
        }));
        var subscribe = tags.subscribe(function (val) { return allDropdownList.push(val); });
        subscribe.unsubscribe();
        console.log(allDropdownList, 'allEmailTag');
        return allDropdownList;
    };
    SetSalesPersonBlockWidgetComponent.prototype.makeEmailAddressDropdownData = function () {
        this.selectedUserInputs['assignTo'] = this.inputModel.assignTo;
        if (this.inputModel.assignTo) {
            this.selectedUserInputs['displayValue'] = this.getDisplayValue(this.inputModel.assignTo);
        }
    };
    SetSalesPersonBlockWidgetComponent.prototype.save = function () {
        this.isFormSubmitted = true;
        var blockObject = tslib_1.__assign({}, this.blockObject);
        blockObject.model = new SetSalesPersonBlockModel(this.form.value);
        this.close.emit({
            action: 'save_and_close',
            data: blockObject
        });
    };
    SetSalesPersonBlockWidgetComponent.prototype.getDisplayValue = function (event) {
        var displayValue = null;
        var selectedGroup = null;
        for (var _i = 0, _a = this.select2Config['data']; _i < _a.length; _i++) {
            var group = _a[_i];
            var match = group.children.find(function (child) { return child.id == event; });
            if (match) {
                displayValue = match.text;
                selectedGroup = group.text;
                break;
            }
        }
        return displayValue;
    };
    SetSalesPersonBlockWidgetComponent.prototype.setToEmailSelect2Config = function () {
        var select2Default = CommonDataSource.select2EmailDefaultConfig;
        this.select2Config = tslib_1.__assign({}, select2Default);
        this.select2Config['data'] = this.makeGroupUserList();
    };
    return SetSalesPersonBlockWidgetComponent;
}());
export { SetSalesPersonBlockWidgetComponent };
